import { createSelector } from 'reselect'

const selectorFactory = (dataSelector) =>
  createSelector(dataSelector, (rates) => (assetName) => rates[assetName] || 0)

const createGetSelector = {
  id: 'get',
  selectorFactory,
  dependencies: [{ selector: 'data' }],
}

export default createGetSelector
